'use client';

import { useEffect } from 'react';
import { usePathname } from 'next/navigation';

/**
 * Aplica a identidade do FluxoSim apenas ao aplicativo interno.
 *
 * Alguns módulos (como Produtos/Serviços e Clientes) não usam AppLayout.
 * Sem esta classe no body, eles herdavam as cores antigas azul/branco.
 * Não alterar o checkout, login, landing, consentimento OAuth nem o
 * orçamento público do cliente: esses fluxos não pertencem ao painel.
 */
const APP_ROUTES = [
  '/assistente',
  '/or-amentos',
  '/ordens-servico',
  '/clientes',
  '/produtos',
  '/estoque',
  '/financeiro',
  '/configuracoes',
  '/caixa',
  '/producao',
] as const;

export default function FluxoSimThemeRoute() {
  const pathname = usePathname();

  useEffect(() => {
    const isApp = pathname === '/' || APP_ROUTES.some(
      (route) => pathname === route || pathname.startsWith(route + '/'),
    );

    document.body.classList.toggle('fluxosim-app', isApp);
    return () => document.body.classList.remove('fluxosim-app');
  }, [pathname]);

  return null;
}
